import React, { useState, useEffect } from 'react';
import AdminNewsTable from './AdminNewsTable';
import Sidebar from './Sidebar';
import NewsAddModal from './NewsAddModal';
import ServicesController from "../hooks/useServicesController";
import NewsModel from './NewsModelHook'



const AdminPanel = () => {
  const [news, setNews] = useState([]);
  const [editing, setEditing] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [category, setCategory] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);

  const fetchNews = async (pageNum = 1, reset = false) => {
    if (isLoading || (!hasMore && !reset)) return;
    setIsLoading(true);
    setError(null);

    try {
      const url = `adminNews?page=${pageNum}&limit=10${category ? `&category=${category}` : ''}`;
      const response = await ServicesController.getServices(url);
      const { news: newArticles = [], hasMore = false } = response || {};
      setNews((prev) => (reset || pageNum === 1 ? newArticles : [...prev, ...newArticles]));
      setHasMore(hasMore);
      setPage(pageNum);
      if (reset) setSelectedIds([]);
    } catch (err) {
      console.error('Axios fetch error:', err);
      setError(err.response?.data?.message || 'Failed to fetch news');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNews(page, false);
    // eslint-disable-next-line
  }, [page, category]);

  useEffect(() => {
    setNews([]);
    setPage(1);
    setHasMore(true);
    setSelectedIds([]);
    fetchNews(1, true);
    // eslint-disable-next-line
  }, [category]);

  const handleSubmit = async (formData) => {
    try {
      await NewsModel.saveNews(formData, editing);
      setEditing(null);
      setIsModalOpen(false);
      fetchNews(1, true);
    } catch (error) {
      console.error('Failed to save news:', error);
      setError('Failed to save news');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this news item?')) {
      try {
        await NewsModel.deleteNews(id);
        fetchNews(1, true);
      } catch (error) {
        console.error('Failed to delete news:', error);
        setError('Failed to delete news');
      }
    }
  };

  const handleBulkDelete = async (ids) => {
    if (window.confirm(`Are you sure you want to delete ${ids.length} news items?`)) {
      try {
        await NewsModel.bulkDeleteNews(ids);
        fetchNews(1, true);
        setSelectedIds([]);
      } catch (error) {
        console.error('Failed to bulk delete news:', error);
        setError('Failed to bulk delete news');
      }
    }
  };

  const handleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((selectedId) => selectedId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedIds.length === news.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(news.map((item) => item.id));
    }
  };

  const handleLoadMore = () => {
    if (hasMore && !isLoading) {
      setPage((prev) => prev + 1);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("userLogin");
    window.location.reload();
};

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="flex min-h-screen bg-gray-100 pt-20">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} onLogout={handleLogout}/>
      <div
        className={`flex-1 p-6 transition-all duration-300 w-full ${isSidebarOpen ? 'ml-[10px]' : 'ml-[10px]'
          }`}
      >
        <div className="flex justify-between items-center mb-2">
          <div>
            <button
              onClick={() => {
                setEditing(null);
                setIsModalOpen(true);
              }}
              className="px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-200 hover:to-indigo-400 hover:text-gray-500 text-white text-2xl font-semibold rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 relative"
            >
              Add News
            </button>
          </div>

          <div>
            <select
              value={category || ''}
              onChange={(e) => {
                console.log('Category:', e.target.value || null);
                setCategory(e.target.value || null);
              }}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2 max-w-xs"
            >
              <option value="">All Categories</option>
              <option value="india">India</option>
              <option value="world">World</option>
              <option value="telangana">Telangana</option>
            </select>
          </div>

        </div>
        {error && <p className="text-red-500 mb-4">{error}</p>}

        <AdminNewsTable
          news={news}
          onEdit={(item) => {
            console.log('Editing item:', item); // Debug
            setEditing(item);
            setIsModalOpen(true);
          }}
          onDelete={handleDelete}
          onBulkDelete={handleBulkDelete}
          isLoading={isLoading}
          hasMore={hasMore}
          loadMore={handleLoadMore}
          selectedIds={selectedIds}
          onSelect={handleSelect}
          onSelectAll={handleSelectAll}
        />
        <NewsAddModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setEditing(null);
          }}
          onSubmit={handleSubmit}
          initialData={editing}
        />
      </div>
    </div>
  );
};

export default AdminPanel;